module.exports = __webpack_public_path__ + "images/embed/graph_icon.gif";